import React from "react";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { gst_details_gstin_note } from "../../GSTDetailsFormGroup.constants";
import styles from "./GSTInfoComponent.module.scss";

const GSTInfoComponent = () => {
    return (
        <div className={styles.container}>
            <InfoOutlinedIcon className={styles.iconStyle} />
            <div className={styles.textStyle}>{gst_details_gstin_note}</div>
        </div>
    );
};

export default GSTInfoComponent;
